/*
Sohel 11/01/2023 5314488544 new MUI table Implemented table data
Guru Prasad 01/11/2023 5314488544 Changed colspan length for table
Sohel 11/02/2023 5314488544 conditionaly added for pronto and IHCP
Sohel 11/07/2023 5314488544 review by data mismatch issue fixed
*/

import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import moment from "moment";
import { Button } from "@material-ui/core";
import EligibilityCoverageInfoUI from "./EligibilityCoverageInfoUI";
import EligibiltyMedicareUI from "./EligibiltyMedicareUI";

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const CustomTableMUI = (props) => {
  const { row, setOpenNote, setEligibilitySummaryId } = props;
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  return (
    <React.Fragment>
      <TableRow className={classes.root}>
        <TableCell>
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>{row?.eligibilityVendor}</TableCell>
        <TableCell>{row?.sentDate ? moment(row?.sentDate).format('MM/DD/YYYY') : ''}</TableCell>
        <TableCell>
          {row?.serviceDate ? moment(row?.serviceDate).format('MM/DD/YYYY') : ''}
        </TableCell>
        <TableCell>
          {row?.responseDate ? moment(row?.responseDate).format('MM/DD/YYYY') : ''}
        </TableCell>
        <TableCell>{row?.outcomeCategory}</TableCell>
        <TableCell>{row?.outcome}</TableCell>
        <TableCell>{row?.reviewDate ? moment(row?.reviewDate).format('MM/DD/YYYY') : ''}</TableCell>
        <TableCell>{row?.reviewBy}</TableCell>
        <TableCell>{row?.reviewStatus}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
             
              <div className="accordion-details-card">
                <div className="accordion-plan-details">
                  <div className="new-standard-textfields d-flex justify-content-end mb-2 reviewed-button">
                    <Button
                      variant="outlined"
                      className={`search-btn`}
                      onClick={() => {
                        setOpenNote(true);
                        setEligibilitySummaryId(row?.eligibilitySummaryId);
                      }}
                    >
                  Review Details
                    </Button>
                  </div>
                  {row?.stateMedicareCoverageInfoResponse ? (
                    <EligibiltyMedicareUI
                      stateMedicaidResponse={row.stateMedicareCoverageInfoResponse}
                    />
                  ) : (
                    <EligibilityCoverageInfoUI coverageInfoData={row?.coverageInfo} />
                  )}
                </div>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default CustomTableMUI;
